import { render, staticRenderFns } from "./FilterSection.vue?vue&type=template&id=2b2c83c2&scoped=true"
import script from "./FilterSection.vue?vue&type=script&lang=js"
export * from "./FilterSection.vue?vue&type=script&lang=js"
import style0 from "./FilterSection.vue?vue&type=style&index=0&id=2b2c83c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c83c2",
  null
  
)

export default component.exports